var _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoadingMd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "200px",
    height: "200px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-50 -50 200 200",
    preserveAspectRatio: "xMidYMid",
    className: "lds-ring",
    style: {
      background: "none"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    "ng-attr-r": "{{config.radius}}",
    "ng-attr-stroke": "{{config.base}}",
    "ng-attr-stroke-width": "{{config.width}}",
    fill: "none",
    r: 30,
    stroke: "#ffffff",
    strokeWidth: 8,
    className: ""
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    "ng-attr-r": "{{config.radius}}",
    "ng-attr-stroke": "{{config.stroke}}",
    "ng-attr-stroke-width": "{{config.innerWidth}}",
    "ng-attr-stroke-linecap": "{{config.linecap}}",
    fill: "none",
    r: 30,
    stroke: "#E1367B",
    strokeWidth: 8.5,
    strokeLinecap: "round",
    transform: "rotate(252 50 50)",
    className: ""
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    calcMode: "linear",
    values: "0 50 50;180 50 50;720 50 50",
    keyTimes: "0;0.5;1",
    dur: "1.5s",
    begin: "0s",
    repeatCount: "indefinite",
    className: ""
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    calcMode: "linear",
    values: "18.84955592153876 169.64600329384882;94.2477796076938 94.24777960769377;18.84955592153876 169.64600329384882",
    keyTimes: "0;0.5;1",
    dur: 1.5,
    begin: "0s",
    repeatCount: "indefinite",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingMd);
export default __webpack_public_path__ + "static/media/loading-md.c3c0f127b91a685c502384e4a0f942d7.svg";
export { ForwardRef as ReactComponent };